// @flow

import React, { Component } from "react";
import ReactDOM from "react-dom";
const { findDOMNode } = ReactDOM;

import styled from "styled-components";
import Tweene from "tweene";
Tweene.defaultTimeUnit = "s";
Tweene.defaultDriver = "gsap";

const $ = window.$;

const HiddenOverflowDiv = styled.div`
  overflow: hidden;
`;

export default class Collapsible extends Component {
  static propTypes = {};

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.animateCollapsible(nextProps.show);
    }
  }

  componentDidMount() {
    const { openHeight = "auto" } = this.props;

    Tweene.set(this.collapsible, {
      height: this.props.show ? openHeight : "0px"
    });
  }

  setCollapsibleNode = collapsible => {
    this.collapsible = collapsible && $(findDOMNode(collapsible));
  };

  animateCollapsible = isOpening => {
    const {
      openHeight = "auto",
      openDelay = "0s",
      openDuration = "0.5s",
      openEasing = "easeOutQuad",
      closeDelay = "0s",
      closeDuration = "0.5s",
      closeEasing = "easeOutQuad"
    } = this.props;

    if (isOpening) {
      Tweene.line(this.collapsible)
        .to({ height: openHeight, delay: openDelay, duration: "0s" })
        .from({ duration: openDuration, height: "0px", easing: openEasing })
        .play();
    } else {
      Tweene.to(this.collapsible, {
        duration: closeDuration,
        height: "0px",
        delay: closeDelay,
        easing: closeEasing
      });
    }
  };

  render() {
    const { children } = this.props;

    return (
      <HiddenOverflowDiv ref={this.setCollapsibleNode}>
        {children}
      </HiddenOverflowDiv>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/collapsible.js